module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Outgoing-mail-fd9c0d48847377cac1d94fc0ec18a325.svg";